<mat-form-field
  class="program-status-selector"
  appearance="outline"
  [matTooltip]="
    ((hasOUWritePermissions$ | async) && (hasWriteAccess === null || hasWriteAccess === undefined)) ||
    (hasWriteAccess !== null && hasWriteAccess !== undefined && hasWriteAccess)
      ? ('program_template_status.status.change.tooltip' | translate)
      : ('program_template_status.status.change.unauthorized.tooltip' | translate)
  "
  >
  <mat-select [formControl]="programTemplateStatus">
    @for (status of allStatuses$ | async; track status) {
      @if (status.id !== EProgramStatus.TEMPLATE) {
        <mat-option
          [class.disabled]="(hasOUWritePermissions$ | async) === false || (hasWriteAccess !== null && hasWriteAccess !== undefined && !hasWriteAccess)"
          (click)="changePublicationStatus(status)"
          [value]="status.id"
          [disabled]="(hasOUWritePermissions$ | async) === false || (hasWriteAccess !== null && hasWriteAccess !== undefined && !hasWriteAccess)"
          >
          {{ 'program.status.' + getProgramStatusName(status.id) | translate }}
        </mat-option>
      }
    }
    @for (additionalStatus of additionalStatuses; track additionalStatus) {
      @if (additionalStatus.id !== EProgramStatus.TEMPLATE) {
        <mat-option
          [class.disabled]="(hasOUWritePermissions$ | async) === false || (hasWriteAccess !== null && hasWriteAccess !== undefined && !hasWriteAccess)"
          (click)="changePublicationStatus(additionalStatus)"
          [value]="additionalStatus.id"
          [disabled]="(hasOUWritePermissions$ | async) === false || (hasWriteAccess !== null && hasWriteAccess !== undefined && !hasWriteAccess)"
          >
          {{ additionalStatus.name | translate }}
        </mat-option>
      }
    }
  </mat-select>
</mat-form-field>
